var unsafeBadgeValues = ['negative', 'positive', 'attention'];
var isUnsafeBadge = function (badge) {
    return unsafeBadgeValues.includes(badge);
};

export { isUnsafeBadge };
